"use client";
"use no memo";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { setCookiesServerWithExpDate } from "@/utils/common/cookiesHelper/CookiesServerUtills";
import { CookiesItemEnum } from "@/utils/enums/CookiesItemEnum";
import { UtmChanelEnum } from "@/utils/enums/UtmChanelEnum";

import { honeycombPageViewHandler } from "./interface/honeycomb";

const AffiliatePageView = () => {
  const searchParam = useSearchParams();
  const affid = searchParam?.get("affid");
  const utmid = searchParam?.get("utmid");
  const pageViewHandler = async () => {
    switch (utmid) {
      case UtmChanelEnum.HONEY_COMB:
        setTimeout(async () => {
          await honeycombPageViewHandler();
          await setCookiesServerWithExpDate(
            CookiesItemEnum.COOKIE_PARTNER_TOKEN_ID,
            affid,
            1,
            undefined,
          );
        }, 100);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    pageViewHandler();
  }, [utmid]);

  return null; // Or any other component you want to render
};

export default AffiliatePageView;
